import * as React from "react";
import * as Immutable from "immutable";
import CommentModel from "../models/CommentModel";
import "./CommentHead.styl";
import CommentDelete from "./CommentDelete";
import UserModel from "../models/UserModel";
import CommentReport from "./CommentReport";
import CommentUser from "./CommentUser";
import CommentBlock from "./CommentBlock";

export default class CommentHead extends React.PureComponent<{
    comment: CommentModel;
    user: UserModel | null;
    authors: Immutable.Set<number>;
    admin: boolean;
    badges: boolean;
    report: boolean;
}> {

    public render(): React.ReactNode {
        return (
            <div className="Discussion-CommentHead-Root">
                <div className="Discussion-CommentHead-User">
                    <CommentUser comment={this.props.comment} authors={this.props.authors} badges={this.props.badges}/>
                </div>
                <div className="Discussion-CommentHead-Buttons">
                    {this.renderBlockButton()}
                    {this.renderDeleteButton()}
                    {this.renderReportButton()}
                </div>
            </div>
        );
    }

    private renderBlockButton(): React.ReactNode {
        if (this.props.admin && this.props.comment.isBlocked() == false) {
            return (
                <div className="Discussion-CommentHead-Button">
                    <CommentBlock comment={this.props.comment}/>
                </div>
            );
        } else {
            return null;
        }
    }

    private renderDeleteButton(): React.ReactNode {
        const comment = this.props.comment;
        const user = this.props.user;
        if (user && comment.getUser() && user.getId() == comment.getUser().getId()) {
            return (
                <div className="Discussion-CommentHead-Button">
                    <CommentDelete comment={comment}/>
                </div>
            );
        } else {
            return null;
        }
    }

    private renderReportButton(): React.ReactNode {
        const comment = this.props.comment;
        const user = this.props.user;
        if (comment.isBlocked() == false && this.props.report !== false) {
            if (!user || !comment.getUser() || comment.getUser().getId() != user.getId()) {
                return (
                    <div className="Discussion-CommentHead-Button">
                        <CommentReport comment={comment}/>
                    </div>
                );
            } else {
                return null;
            }
        }
    }

}